import { memo, useState } from 'react';

import ActivitiesList from './list';
import ActivitiesSearch from './search';
import ActivitiesSearchresult from './searchresult';
import ActivitiesStatus from './status';

import { activitiessearchTypes, activitiesTypes } from '../../../types';
import { checkPaginationCallFn } from '../../../utils/helpers';
import { pageSize } from '../../../utils/constants';
import { useSetBreadcrumb } from 'src/shared/hooks';

interface propsTypes extends activitiessearchTypes {
  activities: activitiesTypes;
  getActivitiesQuotes: any;
  setActivitiesDetails: any;
}

function Quotes(props: propsTypes) {
  const { activities, getActivitiesQuotes, setActivitiesDetails } = props;
  const {
    activities_quotes,
    quotes_internalLoader,
    activitiesSearch,
    activities_quotes_search,
    quotesStatus,
  } = activities;
  const { /*page,*/ result: quoteslist, /*size,*/ total } = activities_quotes;
  const { /*page,*/ result: quoteslist_search, /*size,*/ total: total_search } =
    activities_quotes_search;

  const totalCount = activitiesSearch ? total_search : total;

  useSetBreadcrumb({
    page: 'Activities',
    altname: 'Quotes',
    title: 'Quotes',
    name: 'Quotes',
    menuactive: 'activities',
  });

  // Logic for displaying pagination
  const [currentPages, setCurrentPages] = useState(1);
  const listPerPages = pageSize.default;
  const indexOfLastLists = currentPages * listPerPages;
  const indexOfFirstLists = indexOfLastLists - listPerPages;

  const onPagingClick = (value: number) => {
    if (value !== currentPages) {
      if (checkPaginationCallFn(value, listPerPages, quoteslist, total)) {
        getActivitiesQuotes({
          page: Math.ceil(value / listPerPages) + 1,
          size: 100,
          pagination: true,
        });
      }
      setCurrentPages(Number(value));
    }
  };

  const onSelectChange = (name: any, value: any) => {
    setActivitiesDetails({ quotesStatus: value });
  };

  const finalquoteslist = quoteslist.slice(indexOfFirstLists, indexOfLastLists) || [];

  return (
    <>
      <div className='row'>
        <div className='col-lg-12'>
          <h2 className='arrowWrapper'>
            Quote{totalCount > 1 ? 's' : ''} ({totalCount})
          </h2>
          <ActivitiesStatus
            {...props}
            pagefor='quotes'
            onSelectChange={onSelectChange}
            status={quotesStatus}
            setCurrentPages={setCurrentPages}
          />
        </div>
      </div>
      <div className='row'>
        <ActivitiesSearch {...props} pagefor='quotes' setCurrentPages={setCurrentPages} />
      </div>
      {activitiesSearch ? (
        <ActivitiesSearchresult
          {...props}
          activitieslist={quoteslist_search}
          total={total_search}
          pagefor='quotes'
        />
      ) : (
        <ActivitiesList
          {...props}
          pagefor='quotes'
          InternalLoader={quotes_internalLoader}
          loadermsg='No Quotes Available'
          list={quoteslist}
          finallist={finalquoteslist}
          total={total}
          currentPages={currentPages}
          onPagingClick={onPagingClick}
          listPerPages={listPerPages}
        />
      )}
    </>
  );
}

export default memo(Quotes);
